import PropTypes from 'prop-types';
// @mui
import { useTheme, alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
// components
import Logo from 'src/components/logo';
import TypewriterText from 'src/components/typewriter-text';

// ----------------------------------------------------------------------

export default function AuthModernLayout({ children }) {
    const theme = useTheme();

    return (
        <Box
            component="main"
            sx={{
                height: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',
                overflow: 'hidden',
                background: `linear-gradient(-45deg, #0ba360, #3cba92, #30dd8a, #2bb673)`,
                backgroundSize: '400% 400%',
                animation: 'gradient 15s ease infinite',
                '@keyframes gradient': {
                    '0%': {
                        backgroundPosition: '0% 50%',
                    },
                    '50%': {
                        backgroundPosition: '100% 50%',
                    },
                    '100%': {
                        backgroundPosition: '0% 50%',
                    },
                },
            }}
        >
            <Stack
                direction="row"
                alignItems="center"
                spacing={2}
                sx={{
                    zIndex: 9,
                    position: 'absolute',
                    top: { xs: 16, md: 40 },
                    left: { xs: 16, md: 40 },
                }}
            >
                <Logo />
                <Typography
                    variant="body2"
                    sx={{
                        color: 'common.white',
                        opacity: 0.8,
                        fontWeight: 500,
                        lineHeight: 1.2,
                        textAlign: 'left',
                    }}
                >
                    Конструктор <br />
                    MiniApps в Telegram
                </Typography>
            </Stack>

            <Stack
                spacing={5}
                alignItems="center"
                justifyContent="center"
                sx={{
                    zIndex: 9,
                    width: 1,
                    mt: -10, // Shift content upwards
                }}
            >
                <Stack spacing={1} sx={{ textAlign: 'center', color: 'common.white', maxWidth: 800 }} alignItems="center">
                    <Typography
                        variant="h2"
                        sx={{
                            fontWeight: 300,
                            lineHeight: 1.1,
                        }}
                    >
                        <Box component="span" sx={{ fontStyle: 'italic' }}>
                            Весь
                        </Box>{' '}
                        ваш онлайн-бизнес — <br />
                        <Box component="span" sx={{ fontWeight: 'bold' }}>
                            в одном окне Telegram
                        </Box>
                    </Typography>
                    <TypewriterText
                        texts={[
                            'Выдача курсов',
                            'Автоворонки',
                            'Оплаты',
                            'Клуб по подписке',
                            'Сбор базы',
                        ]}
                        sx={{
                            background: 'linear-gradient(to right, #FFFFFF 0%, #FFD700 40%, #454F5B 50%, #FFD700 60%, #FFFFFF 100%)',
                            backgroundSize: '200% auto',
                            color: 'transparent',
                            WebkitBackgroundClip: 'text',
                            backgroundClip: 'text',
                            animation: 'textGradient 3s linear infinite',
                            '@keyframes textGradient': {
                                '0%': { backgroundPosition: '0% center' },
                                '100%': { backgroundPosition: '200% center' },
                            },
                        }}
                    />
                </Stack>

                <Card
                    sx={{
                        p: 5,
                        width: 1,
                        maxWidth: 480, // Fixed width
                        textAlign: 'center',
                        backdropFilter: 'blur(20px)',
                        backgroundColor: alpha(theme.palette.background.paper, 0.8),
                        border: `1px solid ${alpha(theme.palette.grey[500], 0.16)}`,
                        boxShadow: theme.customShadows.z24,
                        borderRadius: 3, // Apple-style rounded corners
                    }}
                >
                    <Stack spacing={3} sx={{ mb: 5 }}>
                        {children}
                    </Stack>
                </Card>
            </Stack>
        </Box>
    );
}

AuthModernLayout.propTypes = {
    children: PropTypes.node,
};
